export const WHEN_TO_CONTACT_TOPICS = [
  'Dúvida sobre contrato;',
  'Consumo e instalações;',
  'Ajustes Cadastrais',
  'Dúvidas pontuais sobre o Portal e canais digitais;',
  'Informações sobre produtos.',
];

export const RCR_INTRO =
  'Através deste canal você será direcionado ao atendimento da nossa área de RCR (Relacionamento Comercial Remoto) que poderá apoiá-lo.';

export const CONSULTANT_INTRO =
  'Através deste canal você será direcionado ao atendimento do Consultor Comercial que poderá apoiá-lo.';

export const WHEN_TO_CONTACT_RCR_TITLE = 'Quando acionar o RCR:';

export const WHEN_TO_CONTACT_CONSULTANT_TITLE =
  'Quando acionar o Consultor Comercial:';
